import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _descriptor2, _SectionFormLink;
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { Input, setComponentTemplate } from "@ember/component";
import { fn, hash } from "@ember/helper";
import { on } from "@ember/modifier";
import { action } from "@ember/object";
import { service } from "@ember/service";
import DButton from "discourse/components/d-button";
import concatClass from "discourse/helpers/concat-class";
import withEventValue from "discourse/helpers/with-event-value";
import icon from "discourse-common/helpers/d-icon";
import i18n from "discourse-common/helpers/i18n";
import discourseLater from "discourse-common/lib/later";
import IconPicker from "select-kit/components/icon-picker";
import { createTemplateFactory } from "@ember/template-factory";
let SectionFormLink = (_class = (_SectionFormLink = class SectionFormLink extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "site", _descriptor, this);
    _initializerDefineProperty(this, "dragCssClass", _descriptor2, this);
    _defineProperty(this, "dragCount", 0);
  }
  isAboveElement(event1) {
    event1.preventDefault();
    const target1 = event1.currentTarget;
    const domRect1 = target1.getBoundingClientRect();
    return event1.offsetY < domRect1.height / 2;
  }
  dragHasStarted(event1) {
    event1.dataTransfer.effectAllowed = "move";
    this.args.setDraggedLinkCallback(this.args.link);
    this.dragCssClass = "dragging";
  }
  dragOver(event1) {
    event1.preventDefault();
    if (this.dragCssClass !== "dragging") {
      if (this.isAboveElement(event1)) {
        this.dragCssClass = "drag-above";
      } else {
        this.dragCssClass = "drag-below";
      }
    }
  }
  dragEnter() {
    this.dragCount++;
  }
  dragLeave() {
    this.dragCount--;
    if (this.dragCount === 0 && (this.dragCssClass === "drag-above" || this.dragCssClass === "drag-below")) {
      discourseLater(() => {
        this.dragCssClass = null;
      }, 10);
    }
  }
  dropItem(event1) {
    event1.stopPropagation();
    this.dragCount = 0;
    this.args.reorderCallback(this.args.link, this.isAboveElement(event1));
    this.dragCssClass = null;
  }
  dragEnd() {
    this.dragCount = 0;
    this.dragCssClass = null;
  }
}, setComponentTemplate(createTemplateFactory(
/*
  
    <div
      {{on "dragstart" this.dragHasStarted}}
      {{on "dragover" this.dragOver}}
      {{on "dragenter" this.dragEnter}}
      {{on "dragleave" this.dragLeave}}
      {{on "dragend" this.dragEnd}}
      {{on "drop" this.dropItem}}
      role="row"
      data-row-id={{@link.objectId}}
      draggable="true"
      class={{concatClass
        "sidebar-section-form-link"
        "row-wrapper"
        this.dragCssClass
      }}
    >
      {{#if this.site.desktopView}}
        <div class="draggable" data-link-name={{@link.name}}>
          {{icon "grip-lines"}}
        </div>
      {{/if}}

      <div class="input-group" role="cell">
        <IconPicker
          @name="icon"
          @value={{@link.icon}}
          @options={{hash
            maximum=1
            caretDownIcon="caret-down"
            caretUpIcon="caret-up"
            icons=@link.icon
          }}
          @onlyAvailable={{true}}
          @onChange={{fn (mut @link.icon)}}
          aria-label={{i18n "sidebar.sections.custom.links.icon.label"}}
          class={{@link.iconCssClass}}
        />

        {{#if @link.invalidIconMessage}}
          <div class="icon warning" role="alert" aria-live="assertive">
            {{@link.invalidIconMessage}}
          </div>
        {{/if}}
      </div>

      <div class="input-group" role="cell">
        <Input
          {{on "input" (withEventValue (fn (mut @link.name)))}}
          @type="text"
          @value={{@link.name}}
          name="link-name"
          aria-label={{i18n "sidebar.sections.custom.links.name.label"}}
          class={{@link.nameCssClass}}
        />

        {{#if @link.invalidNameMessage}}
          <div role="alert" aria-live="assertive" class="name warning">
            {{@link.invalidNameMessage}}
          </div>
        {{/if}}
      </div>

      <div class="input-group" role="cell">
        <Input
          {{on "input" (withEventValue (fn (mut @link.value)))}}
          @type="text"
          @value={{@link.value}}
          name="link-url"
          aria-label={{i18n "sidebar.sections.custom.links.value.label"}}
          class={{@link.valueCssClass}}
        />

        {{#if @link.invalidValueMessage}}
          <div role="alert" aria-live="assertive" class="value warning">
            {{@link.invalidValueMessage}}
          </div>
        {{/if}}
      </div>

      <DButton
        @icon="trash-alt"
        @action={{fn @deleteLink @link}}
        @title="sidebar.sections.custom.links.delete"
        role="cell"
        class="btn-flat delete-link"
      />
    </div>
  
*/
{
  "id": "5Cte0Alx",
  "block": "[[[1,\"\\n    \"],[11,0],[24,\"role\",\"row\"],[16,\"data-row-id\",[30,1,[\"objectId\"]]],[24,\"draggable\",\"true\"],[16,0,[28,[32,0],[\"sidebar-section-form-link\",\"row-wrapper\",[30,0,[\"dragCssClass\"]]],null]],[4,[32,1],[\"dragstart\",[30,0,[\"dragHasStarted\"]]],null],[4,[32,1],[\"dragover\",[30,0,[\"dragOver\"]]],null],[4,[32,1],[\"dragenter\",[30,0,[\"dragEnter\"]]],null],[4,[32,1],[\"dragleave\",[30,0,[\"dragLeave\"]]],null],[4,[32,1],[\"dragend\",[30,0,[\"dragEnd\"]]],null],[4,[32,1],[\"drop\",[30,0,[\"dropItem\"]]],null],[12],[1,\"\\n\"],[41,[30,0,[\"site\",\"desktopView\"]],[[[1,\"        \"],[10,0],[14,0,\"draggable\"],[15,\"data-link-name\",[30,1,[\"name\"]]],[12],[1,\"\\n          \"],[1,[28,[32,2],[\"grip-lines\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n      \"],[10,0],[14,0,\"input-group\"],[14,\"role\",\"cell\"],[12],[1,\"\\n        \"],[8,[32,3],[[16,\"aria-label\",[28,[32,4],[\"sidebar.sections.custom.links.icon.label\"],null]],[16,0,[30,1,[\"iconCssClass\"]]]],[[\"@name\",\"@value\",\"@options\",\"@onlyAvailable\",\"@onChange\"],[\"icon\",[30,1,[\"icon\"]],[28,[32,5],null,[[\"maximum\",\"caretDownIcon\",\"caretUpIcon\",\"icons\"],[1,\"caret-down\",\"caret-up\",[30,1,[\"icon\"]]]]],true,[28,[32,6],[[28,[31,1],[[30,1,[\"icon\"]]],null]],null]]],null],[1,\"\\n\\n\"],[41,[30,1,[\"invalidIconMessage\"]],[[[1,\"          \"],[10,0],[14,0,\"icon warning\"],[14,\"role\",\"alert\"],[14,\"aria-live\",\"assertive\"],[12],[1,\"\\n            \"],[1,[30,1,[\"invalidIconMessage\"]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n\\n      \"],[10,0],[14,0,\"input-group\"],[14,\"role\",\"cell\"],[12],[1,\"\\n        \"],[8,[32,7],[[24,3,\"link-name\"],[16,\"aria-label\",[28,[32,4],[\"sidebar.sections.custom.links.name.label\"],null]],[16,0,[30,1,[\"nameCssClass\"]]],[4,[32,1],[\"input\",[28,[32,8],[[28,[32,6],[[28,[31,1],[[30,1,[\"name\"]]],null]],null]],null]],null]],[[\"@type\",\"@value\"],[\"text\",[30,1,[\"name\"]]]],null],[1,\"\\n\\n\"],[41,[30,1,[\"invalidNameMessage\"]],[[[1,\"          \"],[10,0],[14,\"role\",\"alert\"],[14,\"aria-live\",\"assertive\"],[14,0,\"name warning\"],[12],[1,\"\\n            \"],[1,[30,1,[\"invalidNameMessage\"]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n\\n      \"],[10,0],[14,0,\"input-group\"],[14,\"role\",\"cell\"],[12],[1,\"\\n        \"],[8,[32,7],[[24,3,\"link-url\"],[16,\"aria-label\",[28,[32,4],[\"sidebar.sections.custom.links.value.label\"],null]],[16,0,[30,1,[\"valueCssClass\"]]],[4,[32,1],[\"input\",[28,[32,8],[[28,[32,6],[[28,[31,1],[[30,1,[\"value\"]]],null]],null]],null]],null]],[[\"@type\",\"@value\"],[\"text\",[30,1,[\"value\"]]]],null],[1,\"\\n\\n\"],[41,[30,1,[\"invalidValueMessage\"]],[[[1,\"          \"],[10,0],[14,\"role\",\"alert\"],[14,\"aria-live\",\"assertive\"],[14,0,\"value warning\"],[12],[1,\"\\n            \"],[1,[30,1,[\"invalidValueMessage\"]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n\\n      \"],[8,[32,9],[[24,\"role\",\"cell\"],[24,0,\"btn-flat delete-link\"]],[[\"@icon\",\"@action\",\"@title\"],[\"trash-alt\",[28,[32,6],[[30,2],[30,1]],null],\"sidebar.sections.custom.links.delete\"]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[\"@link\",\"@deleteLink\"],false,[\"if\",\"mut\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/components/sidebar/section-form-link.js",
  "scope": () => [concatClass, on, icon, IconPicker, i18n, hash, fn, Input, withEventValue, DButton],
  "isStrictMode": true
}), _SectionFormLink), _SectionFormLink), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "site", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dragCssClass", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "dragHasStarted", [action], Object.getOwnPropertyDescriptor(_class.prototype, "dragHasStarted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dragOver", [action], Object.getOwnPropertyDescriptor(_class.prototype, "dragOver"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dragEnter", [action], Object.getOwnPropertyDescriptor(_class.prototype, "dragEnter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dragLeave", [action], Object.getOwnPropertyDescriptor(_class.prototype, "dragLeave"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dropItem", [action], Object.getOwnPropertyDescriptor(_class.prototype, "dropItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dragEnd", [action], Object.getOwnPropertyDescriptor(_class.prototype, "dragEnd"), _class.prototype)), _class);
export { SectionFormLink as default };